"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKEN_REFRESH_EXPIRATION = exports.SCALES_BY_ID = exports.LIGHT_MODE = exports.JA_LOCALE = exports.FEEDBACK_REPORT_FORM_FEATURE_CATEGORIES = exports.FEEDBACK_FORM_TYPES = exports.EN_LOCALE = exports.DARK_MODE = exports.ATTUNED_LOGO_LIGHT = exports.ATTUNED_LOGO_DEFAULT = exports.ATTUNED_LOGO_DARK = exports.ACCESS_DENIED_JA_LIGHT = exports.ACCESS_DENIED_JA_DARK = exports.ACCESS_DENIED_JA = exports.ACCESS_DENIED_EN_LIGHT = exports.ACCESS_DENIED_EN_DARK = exports.ACCESS_DENIED_EN = void 0;

/* eslint-disable max-len */
var TOKEN_REFRESH_EXPIRATION = 'token_refresh_expiration';
exports.TOKEN_REFRESH_EXPIRATION = TOKEN_REFRESH_EXPIRATION;
var EN_LOCALE = 'en';
exports.EN_LOCALE = EN_LOCALE;
var JA_LOCALE = 'ja';
exports.JA_LOCALE = JA_LOCALE;
var SCALES_BY_ID = {
  1: 'security',
  2: 'status',
  3: 'social relationships',
  4: 'competition',
  5: 'rationality',
  6: 'progress',
  7: 'feedback',
  8: 'innovation',
  9: 'altruism',
  10: 'financial needs',
  11: 'autonomy'
};
exports.SCALES_BY_ID = SCALES_BY_ID;
var LIGHT_MODE = 'light';
exports.LIGHT_MODE = LIGHT_MODE;
var DARK_MODE = 'dark';
exports.DARK_MODE = DARK_MODE;
var ATTUNED_LOGO_LIGHT = 'https://content.attuned.ai/common/attuned-logo-light.svg';
exports.ATTUNED_LOGO_LIGHT = ATTUNED_LOGO_LIGHT;
var ATTUNED_LOGO_DARK = 'https://content.attuned.ai/common/attuned-logo-dark.svg';
exports.ATTUNED_LOGO_DARK = ATTUNED_LOGO_DARK;
var ATTUNED_LOGO_DEFAULT = 'https://content.attuned.ai/common/attuned-logo-no-text.svg';
exports.ATTUNED_LOGO_DEFAULT = ATTUNED_LOGO_DEFAULT;
var ACCESS_DENIED_EN = 'https://content.attuned.ai/common/access_denied-en.svg'; // Default is light mode

exports.ACCESS_DENIED_EN = ACCESS_DENIED_EN;
var ACCESS_DENIED_JA = 'https://content.attuned.ai/common/access_denied-ja.svg'; // Default is light mode

exports.ACCESS_DENIED_JA = ACCESS_DENIED_JA;
var ACCESS_DENIED_EN_LIGHT = 'https://content.attuned.ai/common/access_denied-en-light.svg';
exports.ACCESS_DENIED_EN_LIGHT = ACCESS_DENIED_EN_LIGHT;
var ACCESS_DENIED_JA_LIGHT = 'https://content.attuned.ai/common/access_denied-ja-light.svg';
exports.ACCESS_DENIED_JA_LIGHT = ACCESS_DENIED_JA_LIGHT;
var ACCESS_DENIED_EN_DARK = 'https://content.attuned.ai/common/access_denied-en-dark.svg';
exports.ACCESS_DENIED_EN_DARK = ACCESS_DENIED_EN_DARK;
var ACCESS_DENIED_JA_DARK = 'https://content.attuned.ai/common/access_denied-ja-dark.svg';
exports.ACCESS_DENIED_JA_DARK = ACCESS_DENIED_JA_DARK;
var FEEDBACK_FORM_TYPES = ['feedback_report_bug', 'feedback_report_request', 'feedback_report_other'];
exports.FEEDBACK_FORM_TYPES = FEEDBACK_FORM_TYPES;
var FEEDBACK_REPORT_FORM_FEATURE_CATEGORIES = {
  mymotivators: ['feedback_report_form_feature_categories_login', 'feedback_report_form_feature_categories_radar', 'feedback_report_form_feature_categories_goals', 'feedback_report_form_feature_categories_share_goals', 'feedback_report_form_feature_categories_writing_goals', 'feedback_report_form_feature_categories_top_three', 'feedback_report_form_feature_categories_tips', 'feedback_report_form_feature_categories_assessment_report', 'feedback_report_form_feature_categories_favorites', 'feedback_report_form_feature_categories_others']
};
exports.FEEDBACK_REPORT_FORM_FEATURE_CATEGORIES = FEEDBACK_REPORT_FORM_FEATURE_CATEGORIES;